import type { components } from '@/lib/api/schema'

type Session = components['schemas']['SessionResponse']
type AccountSummary = components['schemas']['AccountSummary']

/**
 * The account this session is working in: the one it landed in, or the only one.
 *
 * `last_account_id` is a landing hint, never an authority -- the API checks
 * membership on every request. This only decides what the SPA shows.
 */
export function currentAccount(session: Session): AccountSummary | undefined {
  const accounts = session.accounts ?? []
  return accounts.find((account) => account.id === session.last_account_id) ?? accounts[0]
}

/**
 * Whether this role may create, change and archive agents. The API refuses the
 * rest with 403 either way; this only decides whether the page offers it.
 */
export function canEditAgents(role: string | undefined): boolean {
  return role === 'owner' || role === 'admin'
}

/** Whether this role may connect or disconnect the account's calendar. Everyone sees it. */
export function canManageCalendar(role: string | undefined): boolean {
  return role === 'owner' || role === 'admin'
}

/** Whether this role may talk to an agent from the browser. Staff may; readonly may not. */
export function canTestAgents(role: string | undefined): boolean {
  return role === 'owner' || role === 'admin' || role === 'staff'
}
